import { useState } from "react";
import useAxiosPrivateUpgraded from "./useAxiosPrivateUpgraded";

const useFetchUpgraded = () => {
    const axiosPrivate = useAxiosPrivateUpgraded();

    const [status, setStatus] = useState("idle");
    const [data, setData] = useState(null);

    const fetchData = async ({
        url,
        method = "GET",
        data = null,
        params = null,
        headers = {},
        responseType = "json",
    }) => {
        try {
            setStatus("fetching");

            console.log("=========== API Request ===========");
            console.log({
                method,
                url,
                data,
                params,
                headers,
            });

            const response = await axiosPrivate({
                url,
                method,
                data,
                params,
                headers,
                responseType,
                withCredentials: true,
            });

            console.log("=========== API Response ===========");
            console.log(response.data);

            setData(response.data);
            setStatus("fetched");

            return response.data;
        } catch (error) {
            console.error("=========== API Error ===========");
            console.error(error);

            setStatus("error");

            throw error;
        }
    };

    return {
        status,
        data,
        fetchData,
    };
};

export default useFetchUpgraded;